"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _reactI18next = require("react-i18next");
var _Unstable_Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _FilterAlt = _interopRequireDefault(require("@mui/icons-material/FilterAlt"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _NavigateNext = _interopRequireDefault(require("@mui/icons-material/NavigateNext"));
var _NavigateBefore = _interopRequireDefault(require("@mui/icons-material/NavigateBefore"));
var Filter = function Filter(_ref) {
  var title = _ref.title,
    view = _ref.view,
    onChange = _ref.onChange,
    onNext = _ref.onNext,
    onPrevious = _ref.onPrevious;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: "filter-container",
    sx: {}
  }, /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
    md: 10,
    flex: "1"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2",
    sx: {
      color: theme.palette.text.primary,
      pl: 1
    }
  }, " ", t(title), " ")), /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
    md: 1,
    sx: {
      display: 'flex'
    },
    flex: "1",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-navigate-previous",
    size: "large",
    sx: {
      color: theme.palette.text.main
    },
    "aria-label": t('navigate to previous'),
    onClick: onPrevious
  }, /*#__PURE__*/_react.default.createElement(_NavigateBefore.default, {
    role: "image"
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-navigate-next",
    sx: {
      color: theme.palette.text.main
    },
    size: "large",
    "aria-label": t('navigate to next'),
    onClick: onNext
  }, /*#__PURE__*/_react.default.createElement(_NavigateNext.default, {
    role: "image"
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-filter-menu",
    size: "large",
    sx: {
      color: theme.palette.text.main
    },
    "aria-label": t('change view'),
    "aria-controls": "filter-menu",
    "aria-haspopup": "true",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_FilterAlt.default, {
    role: "image"
  })), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "filter-menu",
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'filter-menu'
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    selected: view === 'default',
    onClick: function onClick() {
      onChange('default');
      setAnchorEl(null);
    }
  }, t('default')), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    selected: view === 'week',
    onClick: function onClick() {
      onChange('week');
      setAnchorEl(null);
    }
  }, t('week')), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    selected: view === 'forthnight',
    onClick: function onClick() {
      onChange('forthnight');
      setAnchorEl(null);
    }
  }, t('forthnight')), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    selected: view === 'month',
    onClick: function onClick() {
      onChange('month');
      setAnchorEl(null);
    }
  }, t('month'))))));
};

// NOTE: Do interpolation based i18n
exports.Filter = Filter;